'use strict';

module.exports = function (rowId) {
  return this.rowsToggleState['row_' + rowId] ? 'VueTables__child-row-toggler--open' : 'VueTables__child-row-toggler--closed';
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/child-row-toggler-class.js